<template>
    <el-container>
        <div class="login-header">
            <el-row>
                <el-col :span="12" class="login_logo" >
                  <img :src="logoUrl">
                </el-col>
                <el-col :span="12" class="login_title">
                    <!-- <p>{{VSystemChinaName}}</p> -->
                </el-col>
            </el-row>
        </div>
<!--      <template v-for="(item,index) in menu">

      </template>

      -->
        <div class="login-main" :style="{backgroundImage:'url('+backgroundUrl+')'}" style="background-size: 100">
            <router-view></router-view>
        </div>
        <el-footer class="login-footer" style="height: 0.25rem;">
<!--            <ul>
                <li v-for="(item, index) of footList" :key="index">
                    <a :href="item.VLine" target="_blank">{{item.VName}}</a>
                </li>
            </ul>-->
            <!-- <p>©2019-2029 jiaotong.con 版权搜友ICP证：京C2-20190302</p>
            <p>浙公网安备 33010602009975号</p> -->
            <p>{{beian}}</p>
        </el-footer>
    </el-container>
</template>

<script>
import { jump,getUser } from '../../untils/auth'
export default {
    name: 'LoginIndex',
    data() {
        return {
            footList: [],
            VLogoUrl: '',
            VSystemChinaName: '',
            beian:'',
            logoUrl:'',
            backgroundUrl:'',
        }
    },
    created () {
        if (getUser()) {
            window.history.back(-1)
        }
      this.axios
        .post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=loginbackground").then((res) => {
        if (res.status == 200) {
          console.log(res)
          if (res.data.status == 200) {
            this.backgroundUrl =res.data.url+res.data.obj[0].VLine;
          }
        }
      });
      /*配置表*/
      this.axios.post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=beian").then((res) => {
        if (res.status == 200) {
          console.log(res)
          if (res.data.status == 200) {
            this.beian =res.data.obj[0].VName;
          }
        }
      });

      /*配置表*/
      this.axios
        .post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=logo").then((res) => {
        if (res.status == 200) {
          console.log(res)
          if (res.data.status == 200) {
            this.logoUrl =res.data.url+res.data.obj[0].VLine;
          }
        }
      });

        this.getInfo();
    },
    methods: {
      jump,
        getInfo() {
            // 获取页头和页脚信息
            this.axios.post(window.IPConfig.IP + '/tBSystemConfig/getById.do?Id=' + this.$store.state.user.VSystemId).then((response) =>{
                if(response.status == 200){
                      this.VLogoUrl = response.data.obj.VLogoUrl
                      this.VSystemChinaName = response.data.obj.VSystemChinaName
                      this.footList = response.data.attributes.winlk
                }
            })
        },

    }
}
</script>

<style>
    .el-container {
        height: 100%;
    }
    .login-header {
        width: 100%;
        /* background: #D4F2E7; */
        position: fixed;
        top: 0;
    }
    .login_logo {
        height: 0.6rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .login_logo img {
        margin-right: 0.1rem;
        height: 100%;
    }
    .login_logo .logo_title {
        font-weight: bold;
    }
    .login_title {
        height: 0.6rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding-right: 0.2rem;
    }
    .login_title p {
        font-size: 0.2rem;
        color: #ffffff;
    }
    .login-main {
        /* height: 7.55rem; */
        height: 100%;
        /* background: #add8e6; */
        /*background: url('../../assets/images/background.jpg') no-repeat center center;*/
        background-size: 100% 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        padding: 0 1.7rem;
    }
    .login-footer {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 0.1rem;
        font-size: 0.16rem;
    }
    .login-footer ul {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 0.1rem;
    }
    .login-footer ul li {
        margin-right: 0.1rem;
    }
    .login-footer ul li:last-child {
        margin-right: 0;
    }
    .login-footer p {
        color: #d3d3d3;
        margin-bottom: 0.1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login/index.vue